// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b827f1a2","239":"d387e439","455":"c6752b42","977":"02d2671f"}[chunkId] + ".chunk.js";
};